module.exports = __webpack_public_path__ + "img/doctor_swap.365d1903.svg";